import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { KeyboardArrowDown } from '@mui/icons-material';
import { DESIGN_TOKENS } from '../../../styles/constants';
import ProductCard, { Product } from '../../ProductCard/ProductCard';

interface MostOrderedProductsProps {
  products: Array<{
    id: string;
    name: string;
    price: string;
    description: string;
    image: string;
    orders: number;
    rank: number;
  }>;
}

const MostOrderedProducts: React.FC<MostOrderedProductsProps> = ({ products }) => {
  const [timeFilter] = useState('Last 30 days');

  // Transform products to match ProductCard interface
  const productCards: Product[] = products.map((product) => ({
    id: product.id,
    name: product.name,
    price: product.price,
    description: `${product.orders} orders`,
    image: product.image,
    status: 'active' as const,
  }));

  return (
    <Box
      sx={{
        backgroundColor: '#FFFFFF',
        borderRadius: '10px',
        padding: '24px',
        boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.1)',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
      }}
    >
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '24px',
          flexWrap: 'wrap',
        }}
      >
        <Typography
          sx={{
            fontFamily: DESIGN_TOKENS.typography.fontFamily,
            fontSize: '16px',
            fontWeight: 700,
            lineHeight: '22.4px',
            letterSpacing: '-0.16px',
            color: '#181818',
          }}
        >
          Most ordered
        </Typography>
        
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            padding: '10px 12px 7px 20px',
            height: '39px',
            backgroundColor: '#FFFFFF',
            border: '1px solid #F1F4F4',
            borderRadius: '16px',
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: '#F6F8F8',
            },
          }}
        >
          <Typography
            sx={{
              fontFamily: DESIGN_TOKENS.typography.fontFamily,
              fontSize: '16px',
              fontWeight: 400,
              lineHeight: '22.4px',
              color: '#181818',
            }}
          >
            {timeFilter}
          </Typography>
          <KeyboardArrowDown sx={{ fontSize: 24, color: '#181818' }} />
        </Box>
      </Box>
      
      {/* Products Grid */}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            sm: 'repeat(2, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(5, 1fr)',
          },
          gap: '24px',
        }}
      >
        {productCards.map((product, index) => (
          <Box
            key={product.id}
            sx={{
              position: 'relative',
            }}
          >
            {/* Rank Badge */}
            <Box
              sx={{
                position: 'absolute',
                top: '8px',
                left: '8px',
                zIndex: 3,
                backgroundColor: '#181818',
                borderRadius: '8px',
                padding: '4px 8px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minWidth: '32px',
                height: '24px',
              }}
            >
              <Typography
                sx={{
                  fontFamily: DESIGN_TOKENS.typography.fontFamily,
                  fontSize: '14px',
                  fontWeight: 700,
                  lineHeight: '19.6px',
                  color: '#FFFFFF',
                }}
              >
                #{products[index].rank}
              </Typography>
            </Box>
            <ProductCard product={product} />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default MostOrderedProducts;
